import { Root } from './rootModel'

export const memberPrivileges = ['readonly', 'readwrite', 'manager', 'god'] as const
export type MemberPrivileges = (typeof memberPrivileges)[number]

export type Member = Root & {
    companyId: string
    email: string
    name?: string
    position?: string
    invitationStatus: 'pending' | 'accepted'
    privileges: MemberPrivileges
}

export type CreateMemberGateway = {
    email: string
    privileges: MemberPrivileges
    name?: string
}

export type CreateMember = CreateMemberGateway

export type UpdateMember = Partial<CreateMember> & {
    id: string
}

export type UpdateMemberGateway = Partial<CreateMemberGateway>

export type CreateOrUpdateMemberForm = {
    id?: string
    email?: string
    privileges?: MemberPrivileges
    name?: string
}
